<template>
    <div>
        <h1 class="documents__title">
            {{ document.title }}
        </h1>
        <div v-html="documentBody" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'TheFeedback',
    computed: {
        ...mapGetters({
            getDocumentByLink : 'documents/getDocumentByLink'
        }),
        document() {
            return this.getDocumentByLink(this.$route.params.link)
        },
        documentBody() {
            return this.document.body
        }
    }
}
</script>